import React from "react";
import { withTranslation } from 'react-i18next';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AddressInput from "./PickUpCash/AddressInput";
import HelpHeader from "./HelpHeader";
import DashboardLocationMap from "../components/DashboardLocationMap";

function DashboardWithActions({
    t,
    balance,
    pickUpLink,
    addBalanceLink = "/add-to-balance",
    hideAddBalanceButton = false,
    onLocationChange,
    onBusinessesLoaded,
    amountPromptKey,
    embedMobileLayout = false,
    mapCenter,
    mapStatus,
    mapSubtext,
    mapAddress,
    showSearchIndicator,
    mapError,
    isMapLoading,
    businesses = [],
    onMarkerClick,
}) {
    const renderEmbeddedMap = () => {
        if (!embedMobileLayout) {
            return null;
        }
        return (
            <div className="dashboard-map-card dashboard-map-card--embedded">
                <div className="dashboard-map-header">
                    <h3>{t('displayMain:map.title')}</h3>
                    <p className="dashboard-map-address">
                        {mapAddress || mapSubtext}
                    </p>
                    <p className="ls-radius-note">
                        {t('location:radius_note')}
                    </p>
                </div>
                <div className="dashboard-map-inner">
                    {showSearchIndicator && (
                        <div className="map-status-pill" style={{color:"grey"}}>
                            <span className="map-status-dot" />
                            {mapStatus}
                        </div>
                    )}
                    {mapCenter && !mapError && !isMapLoading ? (
                        <DashboardLocationMap
                            center={mapCenter}
                            businesses={businesses}
                            onMarkerClick={onMarkerClick}
                        />
                    ) : (
                        <div className="map-placeholder">{mapStatus}</div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="dashboard-with-actions">
            <div className="text-center dashboard-with-actions__content">
                <div className="dashboard-with-actions__balance-row">
                    <div className="dashboard-with-actions__balance-text" style={{display: "flex", flexDirection:"row"}}>
                        <p>{t('display:yourBalance')}:</p>
                        <h3 className="dashboard-balance">${balance}</h3>
                    </div>
                    <div className="dashboard-with-actions__help">

                        <div className="actions">
                            {/* <Link to={pickUpLink} className="buttons-container btn">
                        Pick up cash
                    </Link> */}
                            {!hideAddBalanceButton && (
                                <Link to={addBalanceLink} className="action-button-compact btn">
                                    {t('display:addToBalance')}
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
                <AddressInput
                    onLocationChange={onLocationChange}
                    onBusinessesLoaded={onBusinessesLoaded}
                    amountPromptKey={amountPromptKey}
                />
                {renderEmbeddedMap()}
                <HelpHeader containerStyle={{ display: "inline-flex", position: "static" }} />
            </div>
        </div>
    )
}
export default withTranslation(['display'])(DashboardWithActions);
